import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Button, Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ServiceUnit = ({ unit, description }) => (
  <div className={cn('unit')}>
    <Text size="size5-r-s">{unit}</Text>
    <Text size="size5-r-s" color="grey50">{description}</Text>
  </div>
);

const TarifficationOfLimits = ({ content, onClick, isSeb }) => {
  const services = isSeb ? content : [content[0]];
  return (
    <div>
      <div className={cn('title')}>
        <Text size="size3-m">
          Тарификация при лимитах
        </Text>
      </div>
      <div className={cn('services')}>
        {services.map((service) => <ServiceUnit {...service} />) }
      </div>
      <Button variant="secondary" onClick={onClick}>Понятно</Button>
    </div>
  );
};

ServiceUnit.propTypes = {
  unit: PropTypes.string,
  description: PropTypes.string,
};

TarifficationOfLimits.propTypes = {
  isSeb: PropTypes.bool,
  onClick: PropTypes.func,
  content: PropTypes.arrayOf({
    unit: PropTypes.string,
    description: PropTypes.string,
  }),
};

export { TarifficationOfLimits };
